/* eslint-disable max-len */
import React from 'react';

const SearchIcon: React.FC = () => {

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_13039_397231)">
                <path d="M4 11.998L1 14.999" stroke="#899696" strokeWidth="2" strokeLinecap="round"/>
                <path d="M15 7C15 10.3137 12.3137 13 9 13C5.68629 13 3 10.3137 3 7C3 3.68629 5.68629 1 9 1C12.3137 1 15 3.68629 15 7Z" stroke="#899696" strokeWidth="2"/>
            </g>
            <defs>
                <clipPath id="clip0_13039_397231">
                    <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default SearchIcon;